import React, { useEffect, useRef } from "react"
import classes from './ModelZone.module.css'
import * as THREE from "three";


const ModelZone = ({num3dModel}) => {
  const num3d = num3dModel% 10
  // console.log('num3d :' ,num3d)
  const myModels =[
    {id: 0, a: 1, b: 1, c: 1, color: {r: 255, g: 204, b: 0} },
    {id: 1, a: 2, b: 1, c: 2, color: {r: 255, g: 153, b: 51} },
    {id: 2, a: 3, b: 3, c: 8, color: {r: 255, g: 153, b: 153} },
    {id: 3, a: 4, b: 7, c: 7, color: {r: 255, g: 0, b: 204} },
    {id: 4, a: 5, b: 3, c: 6, color: {r: 153, g: 51, b: 204} },
    {id: 5, a: 6, b: 5, c: 5, color: {r: 102, g: 0, b: 102} },
    {id: 6, a: 7, b: 1, c: 4, color: {r: 51, g: 0, b: 204} },
    {id: 7, a: 8, b: 3, c: 3, color: {r: 51, g: 153, b: 255} },
    {id: 8, a: 9, b: 1, c: 2, color: {r: 102, g: 255, b: 52} },
    {id: 9, a: 10, b: 5, c: 1, color: {r: 0, g: 102, b: 102} }
  ]



    const mountRef = useRef(null);

    useEffect(() => {
  
      var scene = new THREE.Scene();
      var camera = new THREE.PerspectiveCamera( 75, window.innerWidth/window.innerHeight, 0.1, 1000 );
      var renderer = new THREE.WebGLRenderer();
  
      renderer.setSize( window.innerWidth, window.innerHeight );
      mountRef.current.appendChild( renderer.domElement );
  
      var geometry = new THREE.BoxGeometry( myModels[num3d].a, myModels[num3d].b, myModels[num3d].c );
      // var material = new THREE.MeshBasicMaterial( `color: ${myModels[num3d].color}` );
      var material = new THREE.MeshBasicMaterial( { color: 0x00ffff } );
      material.wireframe = true
      material.color = myModels[num3d].color
      // console.log('material: ',material.color)

      var cube = new THREE.Mesh( geometry, material );
  
      scene.add( cube );
      //-----------------\
      //-----------------/

      camera.position.z = 5;
  
      var animate = function () {
        requestAnimationFrame( animate );
        cube.rotation.x += 0.01;
        cube.rotation.y += 0.01;
        renderer.render( scene, camera );
      }
  
      let onWindowResize = function () {
        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();
        renderer.setSize( window.innerWidth, window.innerHeight );
      }
  
      window.addEventListener("resize", onWindowResize, false);
  
      animate();
  
      return () => mountRef.current.removeChild( renderer.domElement);
    }, [num3d]);

    return (
        <div className='model'>
            <div className='model__content'>
                <h3>Zone 3D modelisation:</h3>
                <div className={classes.zone3d}>
                    <div ref={mountRef} className={classes.canvasContainer}></div>
                    {/* <div className={classes.popup3d}>name of model: ... @zolv</div> */}
                </div>
            </div>
        </div>
    )
}

export default ModelZone

